<!--
 * @Author: wangxiaoyu
 * @Date: 2020-03-15 10:30:21
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-03-13 17:22:06
 -->
<template>
  <div class="inner">
    <!-- 面包屑导航 -->
    <!-- <bread-crumb></bread-crumb> -->
    <!-- 个人详情 -->
    <personal-details style="margin-top: 0.1rem"></personal-details>
  </div>
</template>

<script>

import BreadCrumb from '../ivew/breadCrumb'
// import SecondNav from './secondNav';
import PersonalDetails from './personalDetails'
import { getUser } from '../../untils/auth.js'
export default {
  name:'ShopCartIndex',
  components:{
    BreadCrumb,
    // SecondNav,
    PersonalDetails
  },
   created() {
    if (!getUser()) {
      this.$router.push('/login')
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/personalcenter.vue